import { Link, useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";
import { MAIN_SITE_URL } from "@/constants";

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  function goSection(id: string) {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2" aria-label={t("brand")}>
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="text-sm font-bold text-foreground-950">{t("brand")}</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              {t("footer.aboutText")}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.quickLinks")}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <button
                  type="button"
                  onClick={() => goSection("what")}
                  className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.spreadsheet")}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goSection("categories")}
                  className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.categories")}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goSection("qc")}
                  className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.qc")}
                </button>
              </li>
              <li>
                <button
                  type="button"
                  onClick={() => goSection("guides")}
                  className="cursor-pointer text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("nav.guides")}
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.categories")}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {t(`categoryNames.${cat.id}`)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950">{t("footer.resources")}</h4>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link
                  to="/guide/what-is-allchinabuy-spreadsheet"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("guides.card1.title")}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {t("cta.visitMain")}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="max-w-2xl text-xs leading-relaxed text-foreground-500">
            {t("footer.disclaimer")}
          </p>
          <p className="whitespace-nowrap text-xs text-foreground-500">
            © {new Date().getFullYear()} {t("brand")}. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
}